import React, { useState } from 'react';
import { Mail, Info } from 'lucide-react';
import axios from 'axios';
import { API_URL } from '../../api/config';
const RestaurantInfo = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });
  const [email, setEmail] = useState('');

  const handleRecoverRestaurantId = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });
    
    try {
      const response = await axios.post(
        `${API_URL}/recover-restaurant-id`,
        { email }
      );
      
      setStatus({ 
        type: 'success', 
        message: `Success! We've sent details of ${response.data.count} restaurant(s) to your email.` 
      });
      setEmail('');
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to recover restaurant information';
      setStatus({ type: 'error', message: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="bg-white shadow-lg rounded-lg p-6 max-w-sm w-full">
        <div className="text-center mb-6">
          <Info className="text-blue-500 mx-auto" size={48} />
          <h3 className="text-xl font-semibold mt-4">Recover Restaurant Information</h3>
          <p className="text-gray-600">Forgot your restaurant ID? Enter your email below and we'll send you a list of all restaurants associated with your account.</p>
        </div>

        {status.message && (
          <div className={`p-3 mb-4 rounded-md ${status.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
            {status.message}
          </div>
        )}

        <form onSubmit={handleRecoverRestaurantId} className="space-y-4">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              className="w-full pl-10 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
              placeholder="Your Email" 
              required
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            className="w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600 transition duration-200 disabled:opacity-50" 
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Restaurant Details'}
          </button>
        </form>

        <div className="text-center mt-4">
          <a href="/signin" className="text-blue-500 hover:underline">Back to SignIn</a>
        </div>
      </div>
    </div>
  );
};

export default RestaurantInfo;
